import { Component, Injector, OnInit } from "@angular/core";
import { Location } from '@angular/common';
import { AppComponentBase } from "@shared/common/app-component-base";
import { TerminalSettingDto } from "@shared/service-proxies/service-proxies";
import { TerminalSettingsService } from "../terminal/terminal-settings.service";

@Component({
    selector: "app-menu-page",
    templateUrl: "./menu-page.component.html",
    styleUrls: ["./menu-page.component.css", "../../common/styles/congress.css"],
})
export class MenuPageComponent extends AppComponentBase implements OnInit {

    _settings: TerminalSettingDto = undefined;

    constructor(injector: Injector, private _location: Location, private _terminalServiceSettings: TerminalSettingsService) {
        super(injector);
    }

    ngOnInit() {
        this._settings = this._terminalServiceSettings.getSettings();
    }

    back() {
        this._location.back();
    }
}



// WEBPACK FOOTER //
// ./src/congress/shared/layout/menu-page/menu-page.component.ts